import React, {useState} from "react";
import {Table} from "react-bootstrap";
import ModalDialog from "common/components/Modal";
import {ROUND_STATUS_LABEL, roundName} from "./constants";

export default function RoundManagement({api, eventId, rounds, onRefresh, notify}) {
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [targetRound, setTargetRound] = useState(null);
  const [targetStatus, setTargetStatus] = useState("");

  if (!eventId) {
    return <p>이벤트를 먼저 선택해주세요.</p>;
  }

  function openConfirm(round, status) {
    setTargetRound(round);
    setTargetStatus(status);
    setConfirmOpen(true);
  }

  function onConfirm() {
    if (!targetRound) return;
    api.updateWorldcupRoundStatus(targetRound.roundId, targetStatus).then((res) => {
      if (res?.result === "ok") {
        notify("라운드 상태가 변경되었습니다.");
        onRefresh();
      } else {
        notify(res?.message ?? "실패하였습니다.", false);
      }
    }).finally(() => {
      setConfirmOpen(false);
      setTargetRound(null);
    });
  }

  return (
    <article>
      <p style={{marginBottom: 16, color: "#666"}}>
        라운드를 OPEN 하면 다른 OPEN 라운드는 자동으로 CLOSED 됩니다. 현재 진행 라운드만 예측이 가능합니다.
      </p>

      <Table bordered className="basic-table">
        <thead>
        <tr>
          <th>라운드</th>
          <th>코드</th>
          <th>상태</th>
          <th>오픈 시각</th>
          <th>종료 시각</th>
          <th colSpan={2}>관리</th>
        </tr>
        </thead>
        <tbody>
        {rounds?.length > 0 ? rounds.map((round) => (
          <tr key={round.roundId}>
            <td>{round.roundName}</td>
            <td>{round.roundCode}</td>
            <td>{ROUND_STATUS_LABEL[round.status] ?? round.status}</td>
            <td>{round.openAt ?? "-"}</td>
            <td>{round.closedAt ?? "-"}</td>
            <td className="button-cell">
              <button
                type="button"
                className="green-btn"
                disabled={round.status === "OPEN"}
                onClick={() => openConfirm(round, "OPEN")}
              >
                오픈
              </button>
            </td>
            <td className="button-cell">
              <button
                type="button"
                className="dark-btn"
                disabled={round.status === "CLOSED"}
                onClick={() => openConfirm(round, "CLOSED")}
              >
                종료
              </button>
            </td>
          </tr>
        )) : (
          <tr>
            <td colSpan={7}>라운드 데이터가 없습니다. 이벤트 생성 시 기본 라운드가 자동 등록됩니다.</td>
          </tr>
        )}
        </tbody>
      </Table>

      <ModalDialog
        show={confirmOpen}
        onHide={() => setConfirmOpen(false)}
        btnText="예"
        secondBtnText="아니요"
        hasTwoButtons
        onOk={onConfirm}
        onClickSecond={() => setConfirmOpen(false)}
      >
        <p style={{textAlign: "center"}}>
          {roundName(targetRound?.roundCode)} 라운드를
          {targetStatus === "OPEN" ? " 오픈" : " 종료"}
          하시겠습니까?
        </p>
      </ModalDialog>
    </article>
  );
}
